import React from 'react';

import { redWaglLogo } from '../../assets/images/';

interface ILogoProps {
  powered?: boolean;
  poweredText?: string;
}

const Logo = ({ powered, poweredText }: ILogoProps): JSX.Element =>
  powered ? (
    <div className="logo-wrapper powered">
      <div className="logo-sub">{poweredText || 'Powered by '}</div>
      <img src={redWaglLogo} className="logo" alt="logo" />
    </div>
  ) : (
    <div className="logo-wrapper">
      <img src={redWaglLogo} className="logo" alt="logo" />
      <div className="logo-sub">The golf club for golf clubs</div>
    </div>
  );

export { Logo };
